import styled from 'styled-components'

export const NoteContainer = styled.div``
export const NoteTitle = styled.p`
  color: ${({ theme }) => theme.FontColor};
`
